export const style = (theme) => ({
  list: {
    paddingTop: "0px",
  },
  container: {
    padding: "2rem",
    marginBottom: "2rem",
  },
  divider: {
    margin: "1rem 0",
  },
  session: {
    fontSize: "20px",
  },
  containerSwitch: {
    justifyContent: "space-between",
    display: "flex",
    alignItems: "center",
  },
  buttonContainer: {
    padding: "2rem 0rem 0rem",
  },
  button: {
    marginRight: "1rem",
  },
  customCell: {
    padding: "16px",
    color: "#263238",
    cursor: "pointer",
  },
  selectedItem: {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
  nested: {
    paddingLeft: theme.spacing(6),
  },
});
